import _ from 'lodash';
import { IntentLabelConfig } from '../../configs/index';

export const getClonedAdjustment = (adjustment, caseIndex) => {
  const clonedAdjustment = _.cloneDeep(adjustment);

  clonedAdjustment.intents.forEach((intent) => {
    const newLabel = String(Number(IntentLabelConfig.config[caseIndex]) + 1);

    intent.identifier.label = newLabel;
    IntentLabelConfig.setConfigNameAndValue(caseIndex, newLabel);
  });

  return clonedAdjustment;
}
